import {AbstractEvent} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";

export class AfterPlayerCreatedEvent extends AbstractEvent {
  constructor(
    public player: Player,
  ) {
    super();
  }
}